import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./Instructours.module.css";

export default function Instructors() {
  const [instructors, setInstructors] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const { t, i18n } = useTranslation("global");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchInstructors = async (page = 1, lang = "en") => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/instructors?page=${page}`,
        {
          headers: {
            "Accept-Language": lang,
          },
        }
      );


      const data = await response.json();
      setInstructors(data.data);
      setCurrentPage(data.pagination.current_page);
      setLastPage(data.pagination.last_page);
    } catch (error) {
      console.error("Error fetching instructors:", error);
    }
  };

  useEffect(() => {
    const lang = i18n.language || "en";
    fetchInstructors(currentPage, lang);
  }, [currentPage, i18n.language]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= lastPage && page !== currentPage) {
      fetchInstructors(page);
    }
  };
  const [bgImage, setBgImage] = useState("");

    useEffect(() => {
      const fetchSettings = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/setting`);
          const result = await response.json();
          if (result?.data[0]?.image_courses) {
            setBgImage(result.data[0].image_courses);
          }
        } catch (error) {
          console.error("Error fetching settings:", error);
        }
      };
  
      fetchSettings();
    }, []);

  return (
    <>
         <div className={`${styles.instructorsHero} custom-section`} style={{
        backgroundImage: `url(${bgImage})`,
      }}>
        <div className="container">
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>{t("instructorsPage.title")}</h1>
            <h6 className={styles.heroSubtitle}>
              <Link className={styles.heroLink} to="/">
                {t("instructorsPage.home")}
              </Link>
              <span> -</span>
              <span className={styles.secondaryColor}> {t("instructorsPage.title")}</span>
            </h6>
          </div>
        </div>
      </div>

      <section className={`${styles.mainSection} container my-5`}>
        <div className={`container ${styles.instructorsGrid}`}>
          <div className="row">
            {instructors.map((instructor) => (
              <div key={instructor.id} className="col-md-4 mb-3">

                <div className={`${styles.instructorCard} card p-3`}>
                  <Link to={`/instructortDetails/${instructor.id}`}>
                    <img
                      src={instructor.image}
                      className={`${styles.instructorImage} card-img-top`}
                      alt={instructor.name}
                    />
                  </Link>

                  <div className={styles.cardBody}>
                    <Link to={`/instructortDetails/${instructor.id}`}>
                      <h5 className={`${styles.instructorName} fw-bold text-center`}>
                        {instructor.name}
                      </h5>
                      <p className={`${styles.instructorPosition} text-center`}>
                        {instructor.position}
                      </p>
                    </Link>

                    {/* 👇 Social Icons */}
                    <div className={styles.socialIcons}>
                    {instructor?.facebook && (
                      <a href={instructor.facebook} className={`${styles.socialIcon} ${styles.facebook}`} aria-label="Facebook">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    )}

                    {instructor?.twitter && (
                      <a href={instructor.twitter} className={`${styles.socialIcon} ${styles.twitter}`} aria-label="X (Twitter)">
                        <i className="fab fa-x-twitter"></i>
                      </a>
                    )}

                    {instructor?.youtube && (
                      <a href={instructor.youtube} className={`${styles.socialIcon} ${styles.youtube}`} aria-label="YouTube">
                        <i className="fab fa-youtube"></i>
                      </a>
                    )}

                    {instructor?.tiktok && (
                      <a href={instructor.tiktok} className={`${styles.socialIcon} ${styles.tiktok}`} aria-label="TikTok">
                        <i className="fab fa-tiktok"></i>
                      </a>
                    )}

                    {instructor?.whatsapp && (
                      <a href={instructor.whatsapp} className={`${styles.socialIcon} ${styles.whatsapp}`} aria-label="WhatsApp">
                        <i className="fab fa-whatsapp"></i>
                      </a>
                    )}

                    {instructor?.telegram && (
                      <a href={instructor.telegram} className={`${styles.socialIcon} ${styles.telegram}`} aria-label="Telegram">
                        <i className="fab fa-telegram-plane"></i>
                      </a>
                    )}

                    {instructor?.snapchat && (
                      <a href={instructor.snapchat} className={`${styles.socialIcon} ${styles.snapchat}`} aria-label="Snapchat">
                        <i className="fab fa-snapchat-ghost"></i>
                      </a>
                    )}

                    {instructor?.instagram && (
                      <a href={instructor.instagram} className={`${styles.socialIcon} ${styles.instagram}`} aria-label="Instagram">
                        <i className="fab fa-instagram"></i>
                      </a>
                    )}
                  </div>

                    {/* End Social Icons */}
                  </div>
                </div>
              </div>

            ))}
          </div>

          <nav aria-label="Page navigation" className={styles.paginationContainer}>
            <ul className={`pagination ${styles.pagination} justify-content-center mt-4`}>
              <li className={`page-item ${styles.pageItem} ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                  className={`page-link ${styles.pageLink}`}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Prev
                </button>
              </li>

              {Array.from({ length: lastPage }).map((_, index) => {
                const page = index + 1;
                return (
                  <li
                    key={page}
                    className={`page-item ${styles.pageItem} ${page === currentPage ? "active" : ""}`}
                  >
                    <button
                      className={`page-link ${styles.pageLink}`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                );
              })}

              <li
                className={`page-item ${styles.pageItem} ${currentPage === lastPage ? "disabled" : ""}`}
              >
                <button
                  className={`page-link ${styles.pageLink}`}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </section>
    </>
  );
}
